


import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  styled,
  Box,
  CircularProgress,
  Chip,
  Dialog,
  DialogContentText,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  useTheme,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import { authorizationHeader, responseBody } from "util/fetchUtil";
import { TokenManager } from "util/TokenManager";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Autocomplete } from "@material-ui/lab";
import { template } from "lodash";
import { loadDownstreamPartners, loadActiveProjects, loadTechnologyTags, loadDocumentsTemplate, loadDocumentGet, getDocumentById, updateDocuments } from "./projectsApi";

export const Documents = () => {



  const initialFormValues = {
    document_title: "",
    entity: "",
    issued_date: "",
    factory_witness_date: "",
    template_id: null,
    bom: "",
    project: "",
    technology_tags: [],
    product_type: "",
    type: "",
    template_title: "",
    template: "",
  };

  const [formValues, setFormValues] = useState(initialFormValues);

  const [partners, setPartners] = useState([]); // Store downstream partners data
  const [loading, setLoading] = useState(true);

  const [EntityId, setEntityID] = useState("")

  const [fullPageLoader, setFullPageLoader] = useState(false)

  const [projects, setProjects] = useState([]); // Store active projects data
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [loadedOnce, setLoadedOnce] = useState(false);
  const [entitys, setEntitys] = useState([]);
  const [loadingEntitys, setLoadingEntitys] = useState(true);
  const [tags, setTags] = useState([]); // Store types data
  const [loadingTags, setLoadingTags] = useState(true);
  const [Template, setTemplate] = useState([]);
  const [loadingTemplate, setLoadingTemplate] = useState(true);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmTemplateDialog, setOpenConfirmtemplateDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openSaveDialog, setOpenSaveDialog] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [loadingAll, setLoadingAll] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const [hoveredItemId, setHoveredItemId] = useState(null);

  useEffect(() => {
    if (!loading && !loadingProjects && !loadingTags && !loadingTemplate) {
      setLoadingAll(false);
    }
  }, [loading, loadingProjects, loadingTags, loadingTemplate]);


  const [DocumentEdit, setDocumentEdit] = useState({ results: [], count: 0 });

  const [editDocumentId, setEditDocumentId] = useState(0);
  const [editDocumentData, setEditDocumentData] = useState(null);
  const [editDocumentFlag, setEditDocumentFlag] = useState(false);
  const [DocumentExpanedFlag, setDocumentExpanedFlag] = useState(false);
  const [openEditDocumentDialog, setOpenEditDocumentDialog] = useState(false);
  const [filters, setFilters] = useState({
    projectNumber: "",
  });

  const [filterTrigger, setFilterTrigger] = useState(0);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const theme = useTheme();

  const fetchDocuments = async (page, limit) => {
    try {
      setLoading(true);
      const response = await loadDocumentGet(page, limit, filters);
      setDocumentEdit(response);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchDocuments(page, rowsPerPage);
  }, [page, rowsPerPage, filterTrigger]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(rowsPerPage); // reset to first page
  };


  const handleLoadEntity = async () => {
    try {
      const response = await loadDownstreamPartners();
      setPartners(response);
      setEntitys(response);
      setLoading(false); // Set loading to false once data is fetched
    } catch (error) {
      console.error("Error fetching downstream partners:", error);
      setLoading(false); // Even on error, stop loading
    }
  }

  const handleLoadProjects = async () => {
    if (loadedOnce || loadingProjects) return;

    setLoadingProjects(true);
    try {
      const response = await loadActiveProjects(EntityId);
      setProjects(response || []);
      setLoadedOnce(true);
    } catch (error) {
      console.error("Failed to load projects:", error);
    } finally {
      setLoadingProjects(false);
    }
  };

  const handleLoadTags = async () => {
    try {
      const tagsList = await loadTechnologyTags();
      setTags(tagsList);
      setLoadingTags(false); // Set loading to false once data is fetched
    } catch (error) {
      console.error("Error fetching tags:", error);
      setLoadingTags(false); // Even on error, stop loading
    }
  }

  const handleLoadDocumentTemplate = async () => {
    try {
      const documetsList = await loadDocumentsTemplate();

      setTemplate(documetsList);
      setLoadingTemplate(false);
    } catch (error) {
      console.error("Error fetching  document:", error);
      setLoadingTemplate(false);
    }
  }

  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const Product_Type = [
    { value: "modules", label: "Modules" },
    { value: "racking", label: "Racking" },
    { value: "inverter", label: "Inverter" },
    { value: "optimizer", label: "Optimizer" },
    { value: "Power Electronics", label: "Power Electronics" },
    { value: "ess", label: "Energy Storage System" },
  ];
  const Type = [
    { value: "MIAM", label: "Module IAM Report" },
    { value: "INTAKE", label: "Intake" },
    { value: "FWR", label: "Factory Witness Report" },
    { value: "IFT", label: "Inverter Field Testing - Other" },
    { value: "IPQPF", label: "Inverter PQP Final" },
    { value: "IPQPILT", label: "Inverter PQP Interim" },
    { value: "MFT", label: "Module Field Testing - Other" },
    { value: "MINTAKE", label: "Module Intake" },
    { value: "MLID", label: "Module LID" },
    { value: "MDML", label: "Module Mechanical Load (Static, Dynamic, Other)" },
    { value: "MNOCT", label: "Module NOCT" },
    { value: "MPANF", label: "Module PAN File" },
    { value: "MPANR", label: "Module PAN Report" },
    { value: "MPID", label: "Module PID Testing" },
    { value: "MPQPF", label: "Module PQP Final" },
    { value: "MPQPFE", label: "Module PQP Field Exposure" },
    { value: "MPQPI1", label: "Module PQP Interim 1" },
    { value: "MPQPI2", label: "Module PQP Interim 2" },
    { value: "MPQPI3", label: "Module PQP Interim 3" },
    { value: "MISC", label: "Miscellaneous" },
    { value: "MCEY", label: "Module Comparative Energy Yield" },
    { value: "RIE", label: "Racking Installation Efficiency" },
    { value: "BDSI", label: "Backsheet Durability Sequence Interim" },
    { value: "BDS", label: "Backsheet Durability Sequence Final" },
    { value: "ER", label: "Engineering Report" },
    { value: "RTR", label: "Racking or Tracker Report" },
    { value: "ESPQPI", label: "Energy Storage PQP Interim" },
    { value: "ESPQPF", label: "Energy Storage PQP Final" },
    { value: "MPQPFEI", label: "Module PQP Interim Field Exposure" },
    { value: "MLETID", label: "Module LeTID" },
  ];

  const validateForm = (requireTemplateTitle = false) => {
    const errors = {};
    if (!formValues.document_title.trim()) errors.document_title = "Title is required.";
    if (!formValues.entity) errors.entity = "Entity is required.";
    if (!formValues.bom.trim()) errors.bom = "BOM is required.";
    if (!formValues.project) errors.project = "Project is required.";
    if (formValues.technology_tags.length === 0) errors.technology_tags = "At least one technology tag is required.";
    if (!formValues.product_type) errors.product_type = "Product type is required.";
    if (!formValues.type) errors.type = "Type is required.";
    if (requireTemplateTitle && !formValues.template_title?.trim()) {
      errors.template_title = ['Template Title is required'];
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const clearForm = () => {
    setFormValues(initialFormValues);
    setFiles([]);
    setEntityID("");
    setEditDocumentId(0);
    setEditDocumentFlag(false);

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const handleFilterSearch = () => {
    setPage(0);
    setFilterTrigger(t => t + 1);
  };

  const handleClearFilters = () => {
    setFilters({
      projectNumber: "",
    });
    setPage(0);
    setFilterTrigger(t => t + 1);
  };

  const handleDocumentEdit = async (id) => {

    setEditDocumentId(id);


    setEditDocumentFlag(true);

    console.log("document with ID:", id);
    try {
      setFullPageLoader(true);
      const data = await getDocumentById(id);
      setEditDocumentData(data);
      console.info("log", data);

      const entityId = data.entity_id || "";
      setEntityID(entityId)

      setFormValues((prev) => ({
        ...prev,
        document_title: data.title || prev.document_title,
        bom: data.bom || prev.bom,
        product_type: data.product_type || prev.product_type,
        issued_date: data.issued_date || data.issued_date,
        factory_witness_date: data.factory_witness_date || data.factory_witness_date,
        type: data.type || prev.type,
        project: data.project || prev.project,
        entity: data.entity || prev.entity,
        technology_tags: data.technology_tags || prev.technology_tags,

        existingFileUrl: data.file,
        existingFileName: data.name,

      }));


      await Promise.all([
        handleLoadEntity(),
        handleLoadTags(),
      ]);
      if (entityId) {
        const response = await loadActiveProjects(entityId);
        setProjects(response || []);
      }
      setFullPageLoader(false)
    } catch (err) {
      console.error("Error fetching selected document data:", err);
      toast.error("Failed to load document details.");
      setFullPageLoader(false)
    }



  };




  const handleDeleteTemplate = async (id) => {
    try {
      const response = await fetch(`https://portolaprod.azurewebsites.net/api/document_template/${id}/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authorizationHeader(TokenManager.getToken()),
        },
        body: JSON.stringify({ active: false }),
      });
      // const response = await fetch(`https://portolaprod.azurewebsites.net/api/document_template/${id}/`, {
      //   method: 'PATCH',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     Authorization: authorizationHeader(TokenManager.getToken()),
      //   },
      //   body: JSON.stringify({ active: false }),
      // });

      if (response.ok) {
        console.log(`Template with ID ${id} deactivated successfully.`);
        toast.success("Template marked as inactive.");

        setTemplate((prevTemplate) => ({
          ...prevTemplate,
          results: prevTemplate.results.filter((item) => item.id !== id),
        }));

        clearForm();
      } else {
        console.error('Patch failed:', await response.text());
        toast.error("Failed to update the template.");
      }
    } catch (error) {
      console.error('Error updating template:', error);
      toast.error("Something went wrong.");
    }
  };




  const handleTemplateChange = async (e) => {
    const selectedUrl = e.target.value;

    const selectedTemplate = Template.results.find(
      (item) => item.url === selectedUrl
    );

    setFormValues((prev) => ({
      ...prev,
      template: selectedUrl,
      template_id: selectedTemplate?.id || null,
    }));



    try {
      setFullPageLoader(true);
      const response = await fetch(selectedUrl, {
        method: "GET",
        headers: {
          Authorization: authorizationHeader(TokenManager.getToken()),
        },
      });

      if (!response.ok) throw new Error("Failed to fetch template details");


      const data = await response.json();

      const entityId = data.entity_id || "";
      setEntityID(entityId)




      setFormValues((prev) => ({
        ...prev,
        document_title: data.document_title || prev.document_title,
        bom: data.bom || prev.bom,
        product_type: data.product_type || prev.product_type,
        issued_date: data.issued_date || data.issued_date,
        factory_witness_date: data.factory_witness_date || data.factory_witness_date,
        type: data.type || prev.type,
        project: data.project || prev.project,
        entity: data.entity || prev.entity,
        technology_tags: data.technology_tags || prev.technology_tags,
        template_title: data.template_title || prev.Template_title,
      }));


      await Promise.all([
        handleLoadEntity(),
        handleLoadTags(),
      ]);
      if (entityId) {
        const response = await loadActiveProjects(entityId);
        setProjects(response || []);
      }
      setFullPageLoader(false)
    } catch (err) {
      console.error("Error fetching selected template data:", err);
      toast.error("Failed to load template details.");
      setFullPageLoader(false)
    }
  };

  const handleFileUpload = () => fileInputRef.current?.click();

  const handleFilePicked = (event) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles) setFiles(Array.from(uploadedFiles));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (name, date) => {
    const formattedDate = format(new Date(date), "yyyy-MM-dd");
    setFormValues((prev) => ({ ...prev, [name]: formattedDate }));
  };



  const [status, setStatus] = useState("");

  const handleSubmitDocument = async (e) => {
    e.preventDefault();

    if (files.length === 0) {
      toast.error("No file was submitted.");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fix validation errors.");
      return;
    }
    setFullPageLoader(true);


    const formData = new FormData();

    files.forEach((file) => {
      formData.append("file", file);
    });

    formData.append("title", formValues.document_title);
    formData.append("entity", formValues.entity);
    formData.append("issued_date", formValues.issued_date);
    formData.append("factory_witness_date", formValues.factory_witness_date);
    formData.append("bom", formValues.bom);
    formData.append("project", formValues.project);
    formData.append("product_type", formValues.product_type);
    formData.append("type", formValues.type);

    formValues.technology_tags.forEach((tag) => {
      formData.append("technology_tags", tag);
    });


    try {
      const response = await fetch(
        "https://portolaprod.azurewebsites.net/api/documents/",
        {
          method: "POST",
          headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
          },
          body: formData,
        }
      );
      // const response = await fetch(
      //   "https://portolaprod.azurewebsites.net/api/documents/",
      //   {
      //     method: "POST",
      //     headers: {
      //       Authorization: authorizationHeader(TokenManager.getToken()),
      //     },
      //     body: formData,
      //   }
      // );

      if (response.ok) {
        setStatus("File and data uploaded successfully");
        toast.success("Document created successfully.", {
        });
        setOpenConfirmDialog(true)
        clearForm()
        // handleSubmitTemplate(e);
      } else {
        setStatus(`Upload failed: ${response.statusText}`);
        toast.error("Document creation failed.");
      }
      console.log("entity id", EntityId)
      setFullPageLoader(false);
    } catch (err) {

      console.error("Upload error:", err);
      setStatus(" Upload error");
      toast.error("Document creation failed.", err);
      console.log("entity id", EntityId)
    }
    //   window.location.reload();
  };

  const handleSubmitTemplate = async (e, shouldSubmitEntityAfter = false) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fix validation errors.");
      return;
    }

    const formData = new FormData();

    formData.append("document_title", formValues.document_title);
    formData.append("entity", formValues.entity);
    formData.append("issued_date", formValues.issued_date);
    formData.append("factory_witness_date", formValues.factory_witness_date);
    formData.append("bom", formValues.bom);
    formData.append("project", formValues.project);
    formData.append("product_type", formValues.product_type);
    formData.append("type", formValues.type);
    formData.append("template_title", formValues.template_title);

    formValues.technology_tags.forEach((tag) => {
      formData.append("technology_tags", tag);
    });


    try {
      const response = await fetch(
        "https://portolaprod.azurewebsites.net/api/document_template/",
        {
          method: "POST",
          headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
          },
          body: formData,
        }
      );
      // const response = await fetch(
      //   "https://portolaprod.azurewebsites.net/api/document_template/",
      //   {
      //     method: "POST",
      //     headers: {
      //       Authorization: authorizationHeader(TokenManager.getToken()),
      //     },
      //     body: formData,
      //   }
      // );


      if (!response.ok) {
        toast.error("Template creation failed Please note that the Template and Legal Name have already been used");
      } else {


        // if (shouldSubmitEntityAfter) {
        //   handleSubmitDocument(e);
        // }
        setOpenConfirmtemplateDialog(true)
        toast.success("Template created successfully.",
          //    {
          //   onClose: () => window.location.reload(),
          //   autoClose: 3000, // optional
          // }
        );
        clearForm();

      }
    } catch (err) {
      toast.error("Template creation failed.", err);
    }

  };

  const handleUpdate = async () => {
    console.info("edit form values", formValues)

    if (!validateForm()) {
      toast.error("Please fill out all required fields.");
      return;
    }

    const formData = new FormData();

    // if (files.length > 0) {

    //   formData.append("file", files[0]);
    // } else {

    //   formData.append("file", formValues.existingFileUrl);
    // }

    files.forEach((file) => {
      formData.append("file", file);
    });

    formData.append("title", formValues.document_title);
    formData.append("entity", formValues.entity);
    formData.append("issued_date", formValues.issued_date);
    formData.append("factory_witness_date", formValues.factory_witness_date);
    formData.append("bom", formValues.bom);
    formData.append("project", formValues.project);
    formData.append("product_type", formValues.product_type);
    formData.append("type", formValues.type);
    formData.append("document_id", editDocumentId.toString());

    // formValues.technology_tags.forEach((tag) => {
    //   formData.append("technology_tags", tag);
    // });

    formData.append(
      "technology_tags",
      JSON.stringify(formValues.technology_tags)
    );


    try {
      const response = await updateDocuments(formData);

      if (response.ok) {
        setOpenEditDocumentDialog(true)
        toast.success("Document Updated successfully.",
          //   {
          //   onClose: () => window.location.reload(),
          //   autoClose: 3000,
          // }
        );
        clearForm()
      } else {
        const errorText = await response.text();
        console.error("Submission failed:", errorText);
        toast.error(`Failed to update document: ${errorText}`);
      }
    } catch (err) {
      // console.log("customer id", customerIds);
      console.error("Submission error:", err);
      toast.error("Document creation failed.", err);
    }
  }


  const handleSaveTemplate = async (e, shouldSubmitEntityAfter = false) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fix validation errors.");
      return;
    }

    const formData = new FormData();

    formData.append("document_title", formValues.document_title);
    formData.append("entity", formValues.entity);
    formData.append("issued_date", formValues.issued_date);
    formData.append("factory_witness_date", formValues.factory_witness_date);
    formData.append("bom", formValues.bom);
    formData.append("project", formValues.project);
    formData.append("product_type", formValues.product_type);
    formData.append("type", formValues.type);
    formData.append("template_title", formValues.template_title);

    formValues.technology_tags.forEach((tag) => {
      formData.append("technology_tags", tag);
    });


    try {
      const response = await fetch(
        `https://portolaprod.azurewebsites.net/api/document_template/${formValues.template_id}/`,
        {
          method: "PUT",
          headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
          },
          body: formData,
        }
      );
      // const response = await fetch(
      //   `https://portolaprod.azurewebsites.net/api/document_template/${formValues.template_id}/`,
      //   {
      //     method: "PUT",
      //     headers: {
      //       Authorization: authorizationHeader(TokenManager.getToken()),
      //     },
      //     body: formData,
      //   }
      // );
      if (!response.ok) {
        toast.error("Template creation failed Please note that the Template and Legal Name have already been used");
      } else {


        if (shouldSubmitEntityAfter) {
          handleSubmitDocument(e);
        }
        toast.success("Template Updated successfully.", {
          onClose: () => window.location.reload(),
          autoClose: 3000, // optional
        });
        clearForm();

      }
    } catch (err) {
      toast.error("Template creation failed.", err);
    }
  };







  return (

    <>
      <Paper>
        {
          fullPageLoader && (
            <Box
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2000,
              }}
            >
              <CircularProgress size={70} />
            </Box>
          )
        }
        <form onSubmit={handleSubmitDocument}>
          <Grid container spacing={2} style={{ padding: 40 }}>
            <Grid item xs={6}>



              {editDocumentFlag && formValues.existingFileUrl ? (

                <Box>
                  <Typography>Current Document:</Typography>


                  {files.length === 0 && (
                    <a
                      href={formValues.existingFileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {formValues.existingFileName}
                    </a>
                  )}


                  {files.length === 0 && (
                    <>
                      <Typography variant="h5" color="primary">
                        Upload File
                        <img
                          onClick={handleFileUpload}
                          src="/file_upload.svg"
                          alt="Upload Icon"
                          width="30"
                          height="30"
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            verticalAlign: "middle",
                          }}
                        />
                      </Typography>

                      <input
                        ref={fileInputRef}
                        type="file"
                        style={{ display: "none" }}
                        accept="image/*,.pdf"
                        onChange={handleFilePicked}
                      />
                    </>

                  )}


                  {files.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "15px",
                        padding: "10px 15px",
                        // border: "1px solid #ccc",
                        borderRadius: "8px",
                        // background: "#f7f7f7",
                        width: "fit-content",
                      }}
                    >
                      {/* <img
                        src="/file_icon.png"
                        alt="Uploaded File Icon"
                        height={150}
                        width={150}
                      /> */}

                      <Typography variant="body1" style={{ fontWeight: 500, color: "#1976d2" }}>
                        {files[0].name}
                      </Typography>

                      <IconButton
                        size="small"
                        onClick={() => setFiles([])}
                        style={{ color: "grey" }}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </Box>
              ) : (

                <>
                  <Typography variant="h5" color="primary">
                    Upload File
                    <img
                      onClick={handleFileUpload}
                      src="/file_upload.svg"
                      alt="Upload Icon"
                      width="30"
                      height="30"
                      style={{
                        cursor: "pointer",
                        marginLeft: "10px",
                        verticalAlign: "middle",
                      }}
                    />
                  </Typography>

                  <input
                    ref={fileInputRef}
                    type="file"
                    style={{ display: "none" }}
                    accept="image/*,.pdf"
                    onChange={handleFilePicked}
                  />


                  {files.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "15px",
                        padding: "10px 15px",
                        // border: "1px solid #ccc",
                        borderRadius: "8px",
                        // background: "#f7f7f7",
                        width: "fit-content",
                      }}
                    >
                      {/* <img
                        src="/file_icon.png"
                        alt="Uploaded File Icon"
                        height={150}
                        width={150}
                      /> */}

                      <Typography variant="body1" style={{ fontWeight: 500, color: "#1976d2" }}>
                        {files[0].name}
                      </Typography>

                      <IconButton
                        size="small"
                        onClick={() => setFiles([])}
                        style={{ color: "grey" }}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </div>

                  )}
                </>
              )}



            </Grid>

            <Grid item xs={6}>
              <Box display="flex" justifyContent="flex-end">
                {editDocumentFlag ? null : (
                  <FormControl style={{ minWidth: 400 }}>
                    <InputLabel id="type-label">Template</InputLabel>
                    <Select
                      labelId="Template-label"
                      name="template"
                      placeholder="Select template"
                      value={formValues.template}
                      disabled={editDocumentFlag}
                      onOpen={handleLoadDocumentTemplate}
                      onChange={handleTemplateChange}
                    >
                      {loadingTemplate ? (
                        <MenuItem value="">Loading...</MenuItem>
                      ) : (

                        Template.results.map((option) => (
                          <MenuItem
                            key={option.id}
                            value={option.url}
                            onMouseEnter={() => setHoveredItemId(option.id)}
                            onMouseLeave={() => setHoveredItemId(null)}
                          >
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              width="100%"
                            >
                              <span>{option.template_title}</span>

                              {hoveredItemId === option.id && (
                                <Delete
                                  fontSize="small"
                                  sx={{ color: 'red', cursor: 'pointer' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedTemplateId(option.id);
                                    setOpenDeleteDialog(true);
                                  }}
                                />
                              )}
                            </Box>
                          </MenuItem>
                        ))


                      )}
                    </Select>
                  </FormControl>
                )}

              </Box>
            </Grid>


            {/* Title and Entity */}
            <Grid item xs={6}>
              <TextField
                fullWidth
                name="document_title"
                label="Title"
                placeholder="Enter title"
                required
                value={formValues.document_title}
                onChange={handleChange}
                error={!!formErrors.document_title}
                helperText={formErrors.document_title}
              />
            </Grid>
            <Grid item xs={6}>
              {editDocumentFlag ? null : (

                <TextField
                  fullWidth
                  name="template_title"
                  label="Template Title"
                  placeholder="Enter template title"
                  value={formValues.template_title}
                  disabled={editDocumentFlag}
                  onChange={handleChange}
                  error={!!formErrors.template_title}
                  helperText={formErrors.template_title}
                />

              )}
            </Grid>


            <Grid item xs={6}>
              <Autocomplete
                fullWidth
                options={partners?.results || []}
                getOptionLabel={(option) => option.display_name || ""}
                loading={loading}
                onOpen={handleLoadEntity}
                value={
                  partners?.results?.find((e) => e.url === formValues.entity) ||
                  null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "entity",
                      value: newValue ? newValue.url : "",
                    },
                  });


                  setEntityID(newValue?.id || "");
                  setProjects([]);
                  setLoadedOnce(false);

                  if (!newValue) {
                    setFormValues((prev) => ({
                      ...prev,
                      project: "",
                    }));
                  }
                }}

                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Entity"
                    placeholder="Select entity"
                    required
                    error={!!formErrors.entity}
                    helperText={formErrors.entity}
                  />
                )}
                isOptionEqualToValue={(option, value) => option.url === value.url}
              />
            </Grid>

            {/* Dates */}
            <Grid item xs={6}>
              <DatePicker
                label="Issued Date"
                value={formValues.issued_date ? new Date(formValues.issued_date) : null}
                format="yyyy-MM-DD"
                onChange={(date) => handleDateChange("issued_date", date)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <DatePicker
                label="Factory Witness Date"
                value={formValues.factory_witness_date ? new Date(formValues.factory_witness_date) : null}
                format="yyyy-MM-DD"
                onChange={(date) =>
                  handleDateChange("factory_witness_date", date)
                }
                fullWidth
              />
            </Grid>

            {/* BOM and Project */}
            <Grid item xs={6}>
              <TextField
                fullWidth
                name="bom"
                label="BOM"
                placeholder="Enter BOM"
                required
                value={formValues.bom}
                onChange={handleChange}
                error={!!formErrors.bom}
                helperText={formErrors.bom}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                disabled={!formValues.entity}
                fullWidth
                options={projects}
                getOptionLabel={(option) => option.number || ""}
                loading={loadingProjects}
                onOpen={handleLoadProjects} // ✅ Load only when clicked/tapped
                value={projects.find((p) => p.url === formValues.project) || null}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "project",
                      value: newValue ? newValue.url : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Project"
                    required
                    error={!!formErrors.project}
                    helperText={formErrors.project}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingProjects && (
                            <CircularProgress color="inherit" size={20} />
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* Technology Tags */}
            <Grid item xs={6}>
              <Autocomplete
                multiple
                fullWidth
                options={tags?.results || []}
                getOptionLabel={(option) =>
                  `${option.type_text} - ${option.title}`
                }
                loading={loadingTags}
                onOpen={handleLoadTags}
                value={
                  tags?.results?.filter((tag) =>
                    formValues.technology_tags.includes(tag.title)
                  ) || []
                }
                onChange={(event, newValue) => {
                  setFormValues((prev) => ({
                    ...prev,
                    technology_tags: newValue.map((tag) => tag.title),
                  }));
                }}
                isOptionEqualToValue={(option, value) =>
                  option.title === value.title
                }
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip
                      label={`${option.type_text} - ${option.title}`}
                      {...getTagProps({ index })}
                      key={option.id}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Technology Tags"
                    placeholder="Select technology tags"
                    // required
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>

                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>



            <Grid item xs={6}>

              <Autocomplete
                fullWidth
                options={Product_Type}
                getOptionLabel={(option) => option.label}
                value={
                  Product_Type.find(
                    (opt) => opt.value === formValues.product_type
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "product_type",
                      value: newValue ? newValue.value : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Product Type"
                    placeholder="Select product type"
                    required
                    error={!!formErrors.product_type}
                    helperText={formErrors.product_type}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>

            <Grid item xs={6}>

              <Autocomplete
                fullWidth
                options={Type}
                getOptionLabel={(option) => option.label}
                value={Type.find((opt) => opt.value === formValues.type) || null}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "type",
                      value: newValue ? newValue.value : "",
                    },
                  });
                }}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Type"
                    placeholder="Select type"
                    required
                    error={!!formErrors.type}
                    helperText={formErrors.type}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" mt={2}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  style={{ marginRight: 10 }}
                  onClick={editDocumentFlag ? handleUpdate : handleSubmitDocument}
                >
                  {editDocumentFlag ? "Update Document" : "Submit Document"}
                </Button>
                {/* <Button
                type="button"
                variant="contained"
                color="primary"
                style={{ marginLeft: 10 }}
                onClick={handleSaveTemplate}
                disabled={!formValues.template_title.trim()}
              >
                Save Template
              </Button> */}
                <Tooltip title="New Template">
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 10 }}
                    disabled={editDocumentFlag}
                    onClick={handleSubmitTemplate}
                  >
                    Save As Template
                  </Button>
                </Tooltip>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: 10 }}
                  onClick={clearForm}
                >
                  Clear
                </Button>
              </Box>
            </Grid>


          </Grid>

        </form>



        <Dialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
        >
          <DialogTitle>Confirmation status</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The document has been  submitted successfully.

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                setOpenConfirmDialog(false);
                window.location.reload();
              }}
              color="secondary"
            >
              ok
            </Button>

          </DialogActions>
        </Dialog>

        <Dialog
          open={openConfirmTemplateDialog}
          onClose={() => setOpenConfirmtemplateDialog(false)}
        >
          <DialogTitle>Confirmation status</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The document has been successfully saved as a template.

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                setOpenConfirmtemplateDialog(false);
                window.location.reload();
              }}
              color="secondary"
            >
              ok
            </Button>

          </DialogActions>
        </Dialog>



        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
          <DialogTitle>Delete Template</DialogTitle>
          <DialogContent>Are you sure you want to delete this template?</DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)} color="secondary">Cancel</Button>
            <Button
              onClick={() => {
                handleDeleteTemplate(selectedTemplateId);
                setOpenDeleteDialog(false);
              }}
              color="primary"
              variant="contained"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openEditDocumentDialog}
          onClose={() => setOpenEditDocumentDialog(false)}
        >
          <DialogTitle>Confirmation status</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The Documents has been Updated successfully .

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                setOpenEditDocumentDialog(false);
                window.location.reload();
              }}
              color="secondary"
            >
              ok
            </Button>

          </DialogActions>
        </Dialog>


      </Paper>

      <Grid container spacing={2} style={{ alignItems: "center", justifyContent: "center" }}>
        <Grid item style={{ marginTop: "20px" }}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              clearForm();
              setDocumentExpanedFlag(!DocumentExpanedFlag);

            }}

          >
            Update Document Informtion
          </Button>
        </Grid>
      </Grid >


      {DocumentExpanedFlag && (
        <>

          <Grid container spacing={2} style={{ margin: "10px" }}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                variant="outlined"
                label="Project Number"
                size="small"
                value={filters.projectNumber}
                onChange={(e) =>
                  setFilters({ ...filters, projectNumber: e.target.value })
                }
              />
            </Grid>


            {/* Buttons */}
            <Grid item xs={12} sm={6} md={2}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleFilterSearch}
              >
                Search
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleClearFilters}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Paper style={{ margin: "20px 10px" }}>
            <TableContainer style={{ height: "880px" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow style={theme.tableHeaderRow}>

                    <TableCell style={theme.tableHeader}>Name</TableCell>
                    <TableCell style={theme.tableHeader}>Entity Name</TableCell>
                    <TableCell style={theme.tableHeader}>Factory Witness Date</TableCell>
                    <TableCell style={theme.tableHeader}>Issued Date</TableCell>
                    <TableCell style={theme.tableHeader}>Project Number</TableCell>
                    <TableCell style={theme.tableHeader}>Project Type</TableCell>
                    <TableCell style={theme.tableHeader}>Edit</TableCell>

                  </TableRow>
                </TableHead>

                {loading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Box display="flex" justifyContent="center" p={4}>
                          <CircularProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {DocumentEdit.results.map((document) => (
                      <TableRow key={document.id}>
                        <TableCell>{document.title || "N/A"}</TableCell>
                        <TableCell>{document.entity_display_name || "N/A"}</TableCell>
                        <TableCell>{document.factory_witness_date || "N/A"}</TableCell>

                        <TableCell>{document.issued_date || "N/A"}</TableCell>
                        <TableCell>{document.project_number || "N/A"}</TableCell>
                        <TableCell>{document.project_type_text || "N/A"}</TableCell>

                        <TableCell>
                          <IconButton
                            onClick={() => {
                              clearForm();
                              handleDocumentEdit(document.id)
                            }}
                          >
                            <Edit />
                          </IconButton>
                        </TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={DocumentEdit.count || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage=""
            />
          </Paper>

        </>
      )
      }

    </>


  );
};
